import { ACTIONS_COLUMN_ID } from "../constants/dashboardConstants";

const EXCLUDED_KEYS = new Set([
  ACTIONS_COLUMN_ID,
  "actions",
  "livedata",
  "currentlocation",
  "lastupdate",
  "speed",
  "speedlabel",
  "status",
]);

const getHeaderKey = (header = {}) =>
  String(header.key || header.id || header.value || header.label || "")
    .trim()
    .toLowerCase();

export const toInventoryHeaders = (headers = []) =>
  headers
    .filter((header) => {
      const key = getHeaderKey(header);
      const label = String(header.label || header.value || "").trim().toLowerCase();
      if (EXCLUDED_KEYS.has(key)) return false;
      if (label === "actions" || label === "live data" || label === "last update" || label === "status") {
        return false;
      }
      return true;
    })
    .map((header) => ({
      ...header,
      key: header.key || header.id || header.value,
      label: header.label || header.value || header.key,
    }));
